module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3_text"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "lev3"
    }
  }), _vm._v("NEED-TO-KNOW (CASSEROLE) BASES")]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_vm._v("CHICKEN")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_vm._v("For its versatility and ease of access, poultry is by far the most popular meat used in Southern casseroles. Roast or sauté your own or buy it cooked or packaged from the deli. (In a pinch, you can use canned, but you’ll definitely need to liven it up with sauce and seasoning.)")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" 1 pound of bone-in uncooked chicken = about 1 cup cooked shredded/chopped chicken")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" One 12-ounce whole boneless, skinless breast = 1 cup cooked shredded/chopped chicken; a 6-ounce half-breast = "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" cup cooked shredded/chopped chicken")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" One 2- to 3-pound cooked rotisserie chicken = 3 to 4 cups cooked shredded/chopped chicken")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" 1 pound ground chicken = 2 to 2"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cups cooked")])]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "id": "lev4"
    }
  }), _vm._v("Easy & Flavorful Chicken")]), _vm._v(" "), _c('div', {
    staticClass: "image_wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "recipe_hdnote"
  }, [_vm._v("To give typically bland chicken pieces a home-cooked flavor, follow this recipe. Cooking them bone-in will make the meat’s flavor richer. This also will yield a nice stock.")]), _vm._v(" "), _c('div', {
    staticClass: "image_wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    staticClass: "vertical",
    attrs: {
      "alt": "image",
      "src": "images/f0021-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "yield"
  }, [_c('strong', [_vm._v("MAKES 7–8 CUPS COOKED CHICKEN AND 8 CUPS FAT-SKIMMED STOCK")])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("5 to 6 pounds bone-in chicken breasts and, if desired, bone-in thighs")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("1 medium onion, quartered")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("3 celery stalks with tops, quartered")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("3 carrots, quartered")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("2 garlic cloves, halved")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("2 bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("1 tablespoon ground sea or kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingred_list_sub"
  }, [_vm._v("2 teaspoons ground black pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("To an 8-quart or larger stockpot or Dutch oven, add 9 cups water, the chicken, onion, celery, carrots, garlic, bay leaves, salt, and pepper. Bring to a boil over medium heat, about 10 minutes. Cover, reduce the heat, and simmer for 30 to 40 minutes, or until the chicken is tender and a thermometer inserted into the thickest portion registers 160°F (the temperature will rise another 5 degrees before serving). Remove the chicken from the broth and let it cool slightly before attempting to remove and discard the skin and bones. If desired, strain, cool, and refrigerate the stock for other uses. Shred or chop the meat before using as directed.")]), _vm._v(" "), _c('h5', [_vm._v("Storage")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_vm._v("In an airtight container wrapped in aluminum foil, cooked chicken will keep in the refrigerator for up to 4 days and in the freezer for up to 2 months. When freezing, separate chicken pieces, and, if desired, strained broth, into 1- or 2-cup portions placed into smaller bags or containers to be pulled out for future recipes. Strained broth will freeze well for several months.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("MEATLESS")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("TOFU /")])]), _vm._v(" Technically, it’s sliceable bean curd. Actually, it’s delicious if it can be prepared to be as flavorful and crunchy as possible. Cube and fry it in oil and seasoning for 4 to 6 minutes until it turns golden brown, or crisp it in a hot oven with a coating of soy sauce and other seasonings. One pound of tofu equals about 2 cups cooked.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("TEXTURED VEGETABLE BLENDS /")])]), _vm._v(" Chicken-style strips and meat- and sausage-style crumbles are excellent options for more healthful dining. One 12-ounce bag equates to about 1 pound ground beef or about 3 cups.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_vm._v("TURKEY")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GROUND /")])]), _vm._v(" This is a great choice for anyone watching fat intake, but it can taste like cardboard if it’s unseasoned. Fortunately, you now can buy preseasoned ground turkey (I especially like the Italian-flavored variety), but be generous in seasoning it yourself if it’s just plain ground turkey. 1 pound uncooked measures 2 to 2"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" cups cooked.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("BREAST /")])]), _vm._v(" I prefer to roast my own turkey breasts and shred them. One 5- to 7-pound fresh or frozen and thawed turkey breast should cook at 325°F for 2 to 3 hours or to its recommended internal temperature (see chart, facing page). There will be about 3 cups of cooked turkey per pound. Allow 8 ounces per person for generous portions and seconds or leftovers.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_vm._v("PORK")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("HAM /")])]), _vm._v(" A fully cooked bone-in ham is flavorful and versatile. Buy them precooked boneless or bone-in, or cook a 7- to 8-pound bone-in ham at 325°F for 18 to 25 minutes per pound (1 pound equals about 3 cups diced). Diced offers the meatiest texture, but you also can also buy it pre-diced (but in smaller pieces) at the deli.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("LOIN ROASTS /")])]), _vm._v(" These can be found precooked (deliciously so at Mexican grocer delis), or you can cook your own. A 2- to 5-pound roast at 350°F takes 20 to 25 minutes per pound. As with any large cut of meat, cook to about 5 degrees shy of minimum cooking temperature and let it sit for 10 minutes (it will then rise to its ideal temperature). Two pounds of bone-in pork loin equals 1 pound (3 cups) cooked meat.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("SAUSAGE /")])]), _vm._v(" Cook ground sausage until it’s browned through; drain it well before adding to your casserole. Precooked sausage alleviates temperature (and grease) worries. One pound sliced smoked sausage equals about 4 cups; bulk sausage or fattier links (e.g., chorizo) equal 3 to 3"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" cups per pound.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_vm._v("BEEF & LAMB")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("CHUCK ROAST /")])]), _vm._v(" Season a 3- to 4-pound roast to your liking, dust it lightly with all-purpose flour, then sear on all sides in a little oil in a large Dutch oven. Add about 4 cups of seasoned water (I sometimes use a packet of ranch dressing or onion soup mix stirred in) and cook it covered, over medium-low heat for 3 to 4 hours, turning occasionally, until tender and at its recommended internal temperature (see chart, facing page). (This same procedure can be adapted for an equal amount of chuck stew meat chunks.) One pound equals about 3 cups chopped or shredded.\n"), _c('p', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("NOTE:")]), _vm._v(" I don’t advise cooking a less-tender rump roast for a casserole unless you cook it in a slow cooker forever and a day. (For more on using slow cookers, "), _c('span', {
    attrs: {
      "href": "#/xhtml/16_chapter01g#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("see Cooking Low & Slow, page 40")]), _vm._v(".)")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("GROUND /")])]), _vm._v(" Brown meat until it’s cooked through and at its recommended internal temperature (see chart, facing page); drain it well before adding it to your casserole. One pound equals about 3"), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" cups.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2_text"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("SEAFOOD")]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_vm._v("In all cases, use fresh or flash-frozen and thawed, and know that seafood is fully cooked when no longer translucent at the center.")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("SHRIMP /")])]), _vm._v(" Prepeeled, deveined, and uncooked are the best choices for ease and flavor. (Note that precooked shrimp are good for quick stir-fries, cocktails, or salads, but can get tough in casseroles.) Medium-size shrimp (41/50 count per pound) will be a bit sweeter and easier to eat; they also can be cooked right in the casserole. Canned shrimp, rinsed well, are OK for spreads and dips, but small fresh ones will taste less like a tin can.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("CRAWFISH /")])]), _vm._v(" Tails from the Gulf (which I prefer for reasons expressed in the "), _c('span', {
    attrs: {
      "href": "#/xhtml/26_chapter02c#page_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Lil’ Dish” on page 61")]), _vm._v(") are available in convenient 1-pound packages, while imported crawfish come in 12-ounce packets. The latter will always be cheaper, and since it appears close in size to the former, many will grab that smaller package and think they’re getting a good deal. Once home, however, they’ll realize they’ve actually just docked their casserole 4 ounces of precious cargo. So, read the label carefully to know what you’re getting (or not getting).")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("CATFISH NUGGETS /")])]), _vm._v(" These 1- to 2-inch-thick/wide pieces make the best choices for seafood casseroles, especially if they’re flash-seared with a bit of seasoning before going into the dish.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("CRAB, OYSTERS /")])]), _vm._v(" They can be expensive, but they’re so worth having in elegant dishes, particularly ones with light cream sauces that will enhance the delicate seafood instead of overpower it. The crème de la crème of crab is "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("jumbo lump")])]), _vm._v(", which offers the biggest chunks (from the crab’s two back swimming legs), whitest color, firmest texture, and sweetest taste. "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Regular lump")])]), _vm._v(", from the body cavity, is as sweet as jumbo lump but slightly smaller in size and not as vibrant white. "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("Claw meat")])]), _vm._v(" has a stronger flavor and spongier texture. As for "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("canned crab")])]), _vm._v("? I find it too briny, and once rinsed well to rectify that, it becomes too piecey. But it’s usually fine for spreads and dips. Pints of freshly shucked oysters should be purchased from a reputable seafood shop and, like crabmeat, be kept very cold. Canned oysters (regular and smoked) are more affordable options for soups and stews.")]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font3"
  }, [_c('strong', [_vm._v("CANNED TUNA /")])]), _vm._v(" It should be firm and flaky, never mushy. It should be moist but not watery, and certainly not dry. I find springwater–enveloped chunk-light albacore or tongol the best looking and tasting.\n"), _c('p', {
    staticClass: "tip"
  }, [_c('span', {
    staticClass: "font1"
  }, [_vm._v("NOTE:")]), _vm._v(" I don’t suggest using canned salmon for anything other than an emergency situation. I think it tastes downright odd once you’ve had the fresh. (Sorry!)")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_vm._v("Here are the USDA’s minimum recommended internal temperatures for meats and poultry:")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_vm._v("FOOD")])])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_vm._v("MINIMUM INTERNAL TEMP")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Fish, shellfish, lamb")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("145°F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Beef (whole cuts)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("145°F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Pork, ham")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("145°F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Ground beef, sausage")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("160°F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Eggs")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("160°F")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Poultry, stuffed meats")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("165°F")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eecdf42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_chapter01c.vue
// module id = 90
// module chunks = 0